import { FeatureMainAnalyticsView } from './main-analytics';
import { MainAnalyticsProvider } from './main-analytics.provider';

export const FeatureMainAnalytics = () => (
   <MainAnalyticsProvider>
      <FeatureMainAnalyticsView />
   </MainAnalyticsProvider>
);
